export const confirmCloseEditorMessage =
	"Voulez-vous vraiment fermer l'éditeur Markdown ?\n\n" +
	"ATTENTION ! Vos modifications seront perdues si vous n'avez pas copié le contenu.";
